import { OrderHistoryProvider } from 'hooks/context/OrderHistory';
import React, { memo } from 'react';
import { Menu } from 'routes/Menu';
import { RouteFC } from 'util/routeTypes';
import { Matryoshka } from '@clover-util/matryoshka';
import { SubmitOrderProvider } from 'routes/Checkout/context/SubmitOrder/SubmitOrder';
import { OrderDetailsProvider } from 'routes/Checkout/context/OrderDetails';
import { ApplePayProvider } from 'components/ApplePay/ApplePay';
import { OrderResponseSummaryProvider } from 'routes/Checkout/context/OrderResponseSummary';
import { useLocation } from '@reach/router';
import { QUERY_PARAMS } from './LandingPage.const';
import { SessionStorage } from 'util/Storage';
import { OnlineOrderProviders } from 'hooks/useApi/usePostOrdersRequest';

const LANDING_PROVIDERS = [
  OrderHistoryProvider,
  OrderDetailsProvider,
  OrderResponseSummaryProvider,
  ApplePayProvider,
  SubmitOrderProvider,
  Menu
];

export const LandingPage: RouteFC<{ children?: never }> = memo(function LandingPage() {
  const { search } = useLocation();
  const searchParams = new URLSearchParams(search);
  const owgSyncEnabled = searchParams.get(QUERY_PARAMS.utmSource) === 'owg';
  const rwg_token = searchParams.get(QUERY_PARAMS.rwgToken);
  if (owgSyncEnabled) {
    SessionStorage.trySetItem(QUERY_PARAMS.utmSource, OnlineOrderProviders.OWG);
    if (rwg_token){
      SessionStorage.trySetItem(QUERY_PARAMS.rwgToken, rwg_token);
    }
  }

  return (
    <Matryoshka wrappers={LANDING_PROVIDERS} />
  );
});
